import { Component, Vue, Prop } from 'vue-property-decorator';

@Component<MiListItem>({ })
export default class MiListItem extends Vue {
  @Prop({ default: '' })
  protected icon!: string;

  @Prop({ default: '' })
  protected to!: string;

  @Prop({ default: '' })
  protected title!: string;

  @Prop({ default: () => [] })
  protected action!: () => void;
}

export interface Item {
  icon?: string;
  title?: string;
  to?: string;
  action?: () => void;
  visible?: (() => boolean) | boolean;
}
